import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import dayjs from "dayjs";

import {
  Grid,
  Button,
  Card,
  Stack,
  Typography,
  TextField,
  Divider,
} from "@mui/material";
import { useQueryClient } from "react-query";

import { UPDATE_QUOTATION_HEAD } from "../slice/QuotationData";
import { RESET_QUOTATION_TABLE } from "../slice/QuotationTable";
import { useSnackBar } from "src/context/SnackBarContext";
import { deleteData, postData } from "src/views/utilities/api";

import AlertDialog from "./AlertDialog";
import Receipt from "./Receipt";
import Loader from "src/components/Loader";
import { useReactToPrint } from "react-to-print";
import PrintOneThroughProps from "src/views/counterBilling/print/PrintOneThroughProps";
import useFetchData from "src/views/utilities/useFetchData";

function Footer({ setToDefault }) {
  const queryClient = useQueryClient();
const componentRef = useRef(null);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { showSnackbar } = useSnackBar();
  const dispatch = useDispatch();
  const [isReceipt, setIsReceipt] = useState(false);
  const [type, setType] = useState(null);
  const { data:max, isLoading, error } = useFetchData(
        ["max"],
        ["/api/getMaxOfCounter"]
      );
   
      


  const billTable = useSelector((state) => state.quotationTable);
  const billHeader = useSelector((state) => state.quotationMaster);
  const [alert, setAlert] = useState({
    open: false,
    WhatsappOpen: false,
    onConfirm: null,
    onCancel: null,
    title: "",
    message: "",
    buttonType: "",
    buttonText: "",
  });
  useEffect(() => {
    const subTotal = billTable.reduce((acc, cur) => acc + cur.total, 0);
    const discPercAmt = (subTotal * (billHeader.discPerc || 0)) / 100;
    const taxableAmount = subTotal - (billHeader.discAmt || 0) - discPercAmt;
    const taxAmt = (taxableAmount * (billHeader.taxPerc || 0)) / 100;
    const netTotal = taxableAmount + (billHeader.otherChg || 0) + taxAmt;

    dispatch(
      UPDATE_QUOTATION_HEAD({
        total: subTotal,
        discPercAmt,
        taxAmt, // Add tax amount
        netTotal,
      })
    );
  }, [
    billTable,
    billHeader.discPerc,
    billHeader.discAmt,
    billHeader.taxPerc,
    billHeader.otherChg,
    dispatch,
  ]);

  const handleFieldChange = (field, value) => {
    const parsedValue = parseFloat(value) || 0;
    dispatch(
      UPDATE_QUOTATION_HEAD({
        [field]: parsedValue,
      })
    );
  };

  const handleSubmit = async (WhatsApp=false) => {
    if (!billTable[0].item) {
      showSnackbar("error", "Choose item");
      return;
    }
    if (!billHeader.party) {
      showSnackbar("error", "Choose Party");
      return;
    }
   const html = componentRef.current.outerHTML;
    setLoading(true);
    const lastItemRemoved = billTable.slice(0, -1);

    let endPoint;
    if (billHeader.id) {
      endPoint = "updateQuotationBill";
    } else {
      endPoint = "addQuotationBill";
    }
    try {
      const submitBill = await postData(`/api/${endPoint}`, {
        header: {...billHeader,date:dayjs(billHeader.date).format("YYYY-MM-DD 00:00:00"),deliveryDate:dayjs(billHeader.deliveryDate).format("YYYY-MM-DD 00:00:00")},
        table: lastItemRemoved.map((item)=>({...item,deliveryDate:dayjs(item.deliveryDate).format("YYYY-MM-DD 00:00:00")})),
        html,
        WhatsApp
      });
      console.log(billHeader,"billHeaderbillHeaderbillHeaderbillHeader");
      
      if (submitBill.success) {
        showSnackbar("success", submitBill.message);
        // cancelDlg();
        setLoading(false);
        setAlert({
          open: true,
          onConfirm: () => navigateToPrint("QUOTATION"),
          onCancel: cancelDlg,
          title: "Print",
          message: "Do you want to print this bill?",
          buttonType: "info",
          buttonText: "Print",
        });
        // dispatch(RESET_QUOTATION_TABLE());
        // setToDefault(Math.random());
        // queryClient.invalidateQueries("masterData");
      } else {
        showSnackbar("error", submitBill.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const cancelDlg = () => {
    setAlert({
      open: false,
    });
    clearData()
  };

  const clearData = () => {
    setToDefault(Math.random());
    dispatch(RESET_QUOTATION_TABLE());
    queryClient.invalidateQueries("masterData");
  };

  const handleDeleteBill = async () => {
    setLoading(true);

    if (billHeader?.billNo) {
      setLoading(true);
      try {
        const dltBill = await deleteData(
          `/api/deleteQuotationBill?BillNo=${billHeader?.billNo}`
        );
        if (dltBill.success) {
          showSnackbar("error", dltBill.message);
          // setToDefault(Math.random());
          cancelDlg();
          // dispatch(RESET_QUOTATION_TABLE());
          // queryClient.invalidateQueries("masterData");
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    }
    // try {
    //   const deleteBill=
    // } catch {} finally{
    //   setLoading(false)
    // }
  };

  const removeEmptyLastRow = (data) => {
    if (data.length > 0 && !data[data.length - 1].item) {
      data.pop(); // Remove the last row
    }
    return data;
  };

  const updatedTableData = removeEmptyLastRow([...billTable]);

  const billHeaderData = {
    ...billHeader,
    billDate: dayjs(billHeader.date).format("DD/MM/YYYY"),
    billTime: dayjs(billHeader.billTime).format("hh:mm A"),
  };
  const handlePrint = useReactToPrint({
  content: () => componentRef.current,
  onAfterPrint: () => {
    // navigate(-1); // navigates back to the previous page
  }
});
    const navigateToPrint = async (type) => {
   await setType(type)
   handlePrint()

  };
console.log({ header: {...billHeader,date:dayjs().format("YYYY-MM-DD HH:mm:ss")}, table: billTable },"{ header: {...billHeader,date:dayjs().format(YYYY-MM-DD HH:mm:ss)}, table: billTable }");

  
  const handleTransferBill = async() => {
    const {id,...rest}=billHeader
    
    navigate("/counterBilling", {
      state: { header: {...rest,billNo:max?.max?.data?.max_bill_no,date:dayjs().format("YYYY-MM-DD HH:mm:ss"),deliveryDate:dayjs(rest.deliveryDate).format("YYYY-MM-DD HH:mm:ss"),orderNo:rest.billNo}, table: billTable.map((item)=>({...item,deliveryDate:dayjs(item.deliveryDate).format("YYYY-MM-DD HH:mm:ss")})) },
    });
  };
  return (
    <>
      <AlertDialog
        open={alert.open}
        onConfirm={alert.onConfirm}
        onCancel={alert.onCancel}
        title={alert.title}
        message={alert.message}
        buttonType={alert.buttonType}
        buttonText={alert.buttonText}
        WhatsappOpen={alert.WhatsappOpen}
      />
      <Loader start={loading} />

      <Receipt
        open={isReceipt}
        handleClose={() => setIsReceipt(false)}
        billSave={handleSubmit}
      />

      <Grid container spacing={1} alignItems="flex-start">
        <Grid item xs={12} sm={6} md={8} container spacing={1}>
          <Grid item xs={6} sm={4} md={3} lg={2}>
            <Button
              disabled={!billTable[0].item}
              variant="contained"
              color="success"
              fullWidth
              // onClick={handleSubmit}
              onClick={() =>
                setAlert({
                  open: true,
                  onConfirm: handleSubmit,
                  onCancel: cancelDlg,
                  title: "Save bill",
                  message: "Do you want save this Quotation?",
                  buttonType: "primary",
                  buttonText: "Save bill",
                  WhatsappOpen:true
                })
              }
            >
              Save
            </Button>
          </Grid>
          <Grid item xs={6} sm={4} md={3} lg={2}>
            <Button
              onClick={() => navigateToPrint("QUOTATION")}
              disabled={!billHeader.id}
              variant="contained"
              color="primary"
              fullWidth
            >
              Print
            </Button>
          </Grid>
          <Grid item xs={6} sm={4} md={3} lg={2}>
            <Button
              disabled={!billHeader.id}
              variant="contained"
              // onClick={() => navigateToPrint("QUOTATION")}
              onClick={handleTransferBill}
              color="info"
              fullWidth
            >
              Transfer
            </Button>
          </Grid>
          <Grid item xs={6} sm={4} md={3} lg={2}>
            <Button
              variant="contained"
              color="warning"
              fullWidth
              onClick={clearData}
            >
              Clear
            </Button>
          </Grid>
          {/* <Grid item xs={6} sm={4} md={3} lg={2}>
            <Button variant="contained" color="secondary" fullWidth>
              Back
            </Button>
          </Grid> */}
          <Grid item xs={6} sm={4} md={3} lg={2}>
            <Button
              disabled={!billHeader.id}
              variant="contained"
              color="error"
              fullWidth
              onClick={() =>
                setAlert({
                  open: true,
                  onConfirm: () => handleDeleteBill(),
                  onCancel: cancelDlg,
                  title: "Delete bill",
                  message: "Do you want to delete this bill?",
                  buttonType: "error",
                  buttonText: "Delete",
                })
              }
              // onClick={handleDeleteBill}
            >
              Delete
            </Button>
          </Grid>
          <Grid item xs={0} sm={8} md={9} />

          <Grid item xs={12} sm={12} md={3}>
            <Button
              variant="contained"
              color="success"
              fullWidth
              onClick={() => setIsReceipt(true)}
            >
              Receipt
            </Button>
            <Typography variant="h6" mt={2}>
              Balance: {billHeader.balance}
            </Typography>
            <Typography variant="h6" mt={2}>
              Receipt Amount: {billHeader.receiptAmt}
            </Typography>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={6} md={4} container spacing={2}>
          <Grid item xs={12}>
            <Card>
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ p: 1 }}
              >
                <Typography variant="subtitle1">Subtotal:</Typography>
                <Typography variant="subtitle1">{billHeader.total}</Typography>
              </Stack>
              <Divider />
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ p: 1 }}
              >
                <Typography variant="subtitle1">Discount %:</Typography>
                <Stack direction="row" alignItems="center" gap={2}>
                  <TextField
                    type="number"
                    sx={{ width: 60 }}
                    size="small"
                    value={billHeader.discPerc || 0}
                    onChange={(e) =>
                      handleFieldChange("discPerc", e.target.value)
                    }
                  />
                  <Typography variant="subtitle1">
                    {billHeader.discPercAmt || 0}
                  </Typography>
                </Stack>
              </Stack>
              <Divider />
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ p: 1 }}
              >
                <Typography variant="subtitle1">Discount Amount:</Typography>
                <TextField
                  type="number"
                  sx={{ width: 100 }}
                  size="small"
                  value={billHeader.discAmt || 0}
                  onChange={(e) => handleFieldChange("discAmt", e.target.value)}
                />
              </Stack>
              <Divider />
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ p: 1 }}
              >
                <Typography variant="subtitle1">Tax %:</Typography>
                <Stack direction="row" alignItems="center" gap={2}>
                  <TextField
                    type="number"
                    sx={{ width: 100 }}
                    size="small"
                    value={billHeader.taxPerc || 0}
                    onChange={(e) =>
                      handleFieldChange("taxPerc", e.target.value)
                    }
                  />
                  <Typography variant="subtitle1">
                    {billHeader.taxAmt}
                  </Typography>
                </Stack>
              </Stack>
              <Divider />
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ p: 1 }}
              >
                <Typography variant="subtitle1">Other Charge:</Typography>
                <TextField
                  type="number"
                  sx={{ width: 100 }}
                  size="small"
                  value={billHeader.otherChg || 0}
                  onChange={(e) =>
                    handleFieldChange("otherChg", e.target.value)
                  }
                />
              </Stack>
              <Divider />
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ p: 1 }}
              >
                <Typography variant="h6">Net Total:</Typography>
                <Typography variant="h6">{billHeader.netTotal || 0}</Typography>
              </Stack>
              <Divider />
            </Card>
          </Grid>
        </Grid>
        <div style={{display:"none"}}>
        <PrintOneThroughProps state={ { header: billHeaderData, table: updatedTableData, type: "QUOTATION" } } componentRef={componentRef} handlePrint={handlePrint}/>
        </div>
      </Grid>
    </>
  );
}

export default Footer;

Footer.propTypes = {
  setToDefault: PropTypes.func,
};
